
import React from 'react';
import AdsPageLayout from '../Components/AdsPage/AdsPageLayout';
import { adsPageConfigs, commonComparisonData, commonAdvantages } from '../Components/AdsPage/adsData';
import schemaAINoCI from "../Assets/Images/SchemaFacturation/SchemaAeNoCi.png";

export default function AeNoCiPageAds() {
  const config = adsPageConfigs.aeNoCi;
  
  // Données spécifiques pour cette page
  const comparisonData = [
    ...commonComparisonData.slice(0, 2), // Garde les 2 premiers éléments identiques
    {
      label: "Remboursement de 50% instantané",
      system: 0,
      aici: 1,
    },
    {
      label: "Avoir la main sur vos paiements",
      system: 0,
      aici: 1,
    },
    {
      label: "Vous ne gérez ni l'administratif ni la facturation",
      system: 0,
      aici: 1,
    },
  ];

  return (
    <AdsPageLayout
      {...config}
      comparisonData={comparisonData}
      advantages={commonAdvantages}
      currentSituationImage={schemaAINoCI}
    />
  );
}
